export default {
  company: "บริษัท",
  share_holder: "หุ้นส่วน",
  super_senior: "ซูเปอร์ซีเนียร์",
  senior: "ซีเนียร์",
  master: "มาสเตอร์",
  agent: "เอเยนต์",
  member: "สมาชิก",

  account_id: "รหัสผู้ใช้",
  action: "ปฏิบัติ",
  available_credit: "ใช้ได้ เครดิต",
  active: "ใช้งานอยู่",
  account_balance: "ยอดดุลบัญชี",
  agent_credit: "เครดิตเอเย่นต์",
  authority: "ผู้มีอำนาจ",
  account_information: "ข้อมูลเกี่ยวกับบัญชี",
  account_list: "รายชื่อบัญชี",
  audit_by: "Audit By",
  add_account: "เพิ่ม บัญชี ",
  add_sub_account: "เพิ่ม บัญชีย่อย",
  authority_option: "ตัวเลือกผู้มีอำนาจ",
  account: "บัญชี ",
  access_log: "เข้าถึงบันทึก",
  account_log: "บันทึกบัญชี",
  account_details: "รายละเอียดบัญชี",
  action_by: "ดำเนินการโดย",
  away_team_name: "ชื่อทีมเยือน",
  amount: "จำนวน",
  account_before_balance: "บัญชีก่อนยอดเงิน",
  account_after_balance: "บัญชีหลังจากยอดคงเหลือ",
  active_bet_list: "คล่องแคล่วรายการเดิมพัน",
  agent_win_all: "Agent Win All",
  agent_win_half: "Agent Win Half",
  agent_lose_all: "Agent Lose All",
  agent_lose_half: "Agent Lose Half",
  accumulate_win: "Accumulated Win",
  add_sub: "เพิ่ม บัญชีย่อย",
  account_type: "ประเภทบัญชี",
  account_pt: "บัญชีผู้ใช้ PT",
  account_min: "บัญชีขั้นต่ำ",
  away_score: "คะแนนทีมเยือน",
  add_secondary_full: "Add Secondary Account",
  accumulate_balance: "สะสมยอดเงิน",
  away: "ทีมเยือน",
  aa: "ครึ่งเวลา: ทีมเยือน | เต็มเวลา: ทีมเยือน",
  ad: "ครึ่งเวลา: ทีมเยือน l เต็มเวลา: เสมอกัน",
  ah: "ครึ่งเวลา: ทีมเยือน l เต็มเวลา: ทีมเหย้า",
  anb: "ไม่มีการวางเดิมพันทีมเยือน",
  all: "ทั้งหมด",
  account_existed: "บัญชีย่มีอยู่.",
  account_not_existed: "บัญชีย่ไม่มีอยู่.",
  account_status: "บัญชีย่สถานะ",
  account_block: "Account Block",
  account_unblock: "Account Unblock",
  add_secondary: "Add Secondary Account",
  agent_bulk: "Agent Bulk",

  balance: "ยอดคงเหลือ",
  bet: "เดิมพัน",
  block: "Block",
  blocked: "Blocked",
  back: "กลับ",
  bet_limit: "จำกัดการเดิมพัน",
  basketball: "บาสเกตบอล",
  baseball: "เบสบอล",
  bet_limit_log: "บันทึกจำกัดการเดิมพัน",
  browser_agent: "ตัวแทนเบราว์เซอร์",
  bet_limit_packages: "แพ็คเกจ จำกัด การเดิมพัน",
  ball: "ลูกบอล",
  bet_count: "นับเดิมพัน",
  bet_type: "ประเภทของการเดิมพัน",
  bl: "จำกัดการเดิมพัน",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "รายการ",
  bs: "ทั้งคู่มีสกอร์",

  credit: "เครดิต",
  cm: "คอมมิชชั่น",
  close: "ปิด",
  cancel: "ยกเลิก",
  continue: "ต่อ",
  created_on: "สร้างบน",
  copy_and_create: "คัดลอกและสร้าง",
  copy: "สำเนา",
  confirm_password: "ยืนยันรหัสผ่าน",
  confirm_security_code: "ยืนยันรหัสความปลอดภัย",
  contact_phone: "โทรศัพท์",
  contact_email: "อีเมล",
  cash_balance: "ยอดเงินสดคงเหลือ",
  currency: "สกุลเงิน",
  credit_limit: "เครดิตจำกัด",
  credit_balance: "เครดิต/ยอดคงเหลือ",
  commission: "คอมมิชชั่น",
  correct_score: "สกอร์ถูกต้อง",
  commission_log: "คอมมิชชั่น",
  current_balance: "ยอดเงินปัจจุบัน",
  cancelled_bet_list: "ยกเลิกรายการพนัน",
  category: "ประเภท",
  copy_to_bottom: "คัดลอกไปด้านล่าง",
  comm_sportsbook_hdp_a: "แฮนดีแคพ A",
  comm_sportsbook_hdp_b: "แฮนดีแคพ B",
  comm_sportsbook_hdp_c: "แฮนดีแคพ C",
  comm_sportsbook_hdp_d: "แฮนดีแคพ D",
  comm_sportsbook_hdp_e: "แฮนดีแคพ E",
  comm_sportsbook_hdp_f: "แฮนดีแคพ F",
  comm_sportsbook_hdp_g: "แฮนดีแคพ G",
  comm_sportsbook_hdp_h: "แฮนดีแคพ H",
  comm_sportsbook_hdp_i: "แฮนดีแคพ I",
  comm_sportsbook_hdp_j: "แฮนดีแคพ J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "อื่น",
  comm_sportsbook_hdp_packages: "แพ็คเกจแฮนดิแคป",
  comm_slots: "เกมสล็อต",
  comm_casino: "คาสิโน สด",
  comm_lotto: "สลากกินแบ่ง",
  comm_keno: "คีโน่",
  comm_cockfight: "ชนไก่",
  comm_lottery_1d: "สลากกินแบ่ง 1D",
  comm_lottery_2d: "สลากกินแบ่ง 2D",
  comm_lottery_3d: "สลากกินแบ่ง 3D",
  comm_lottery_4d: "สลากกินแบ่ง 4D",
  completed: "สมบูรณ",
  clean_sheet: "สะอาด แผ่น",
  cockfight: "ชนไก่",
  cockfight_bet_limit_packages: "แพคเกจ จำกัด เดิมพัน Cockfight",
  close_room: "ปิดห้อง",
  close_bet: "ปิดการเดิมพัน",
  create_room: "สร้างห้อง",
  match_selection: "เลือกแมตช์",
  selected_match: "แมตช์ที่เลือก",
  insert: "แทรก",
  active_reopen: "เปิดใช้งาน / เปิดอีกครั้ง",

  combine: {
    bet_limit_A: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_KRWA: "Limit A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "Limit B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "Limit C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "Limit D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "Limit E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "Limit F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "Limit G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CNYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_CNYD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_CNYE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_CNYF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_CNYG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_HKDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "Limit B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "Limit C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "Limit D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "Limit E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
    
    bet_limit_VNDA: "Limit A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "Limit B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "Limit C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "Limit D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "Limit E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "Limit F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "Limit G (@:ui.min = 80 @:ui.max = 150,000)",
	
	  bet_limit_MYRA: "Limit A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "Limit B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "Limit C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "Limit D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "Limit E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "Limit F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "Limit G (@:ui.min = 500 @:ui.max = 20,000)",
	
	  bet_limit_USDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "Limit C (@:ui.min = 2 @:ui.max = 400)",
    bet_limit_USDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
	
	  bet_limit_THBA: "Limit A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "Limit B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "Limit C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "Limit D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "Limit E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "Limit F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "Limit G (@:ui.min = 100 @:ui.max = 300,000)",
	
	  bet_limit_IDRA: "Limit A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "Limit B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "Limit C (@:ui.min = 25 @:ui.max = 3,000)",
    bet_limit_IDRD: "Limit D (@:ui.min = 50 @:ui.max = 15,000)",
    bet_limit_IDRE: "Limit E (@:ui.min = 50 @:ui.max = 30,000)",
    bet_limit_IDRF: "Limit F (@:ui.min = 50 @:ui.max = 60,000)",
    bet_limit_IDRG: "Limit G (@:ui.min = 50 @:ui.max = 100,000)",

    comm_limit_A: "A (@:ui.hdp/@:ui.ou/@:ui.oe) 5%",
    comm_limit_B: "B (@:ui.hdp/@:ui.ou/@:ui.oe) 6%",
    comm_limit_C: "C (@:ui.hdp/@:ui.ou/@:ui.oe) 7%",
    comm_limit_D: "D (@:ui.hdp/@:ui.ou/@:ui.oe) 8%",
    comm_limit_E: "E (@:ui.hdp/@:ui.ou/@:ui.oe) 9%",
    comm_limit_F: "F (@:ui.hdp/@:ui.ou/@:ui.oe) 10%",
    comm_limit_G: "G (@:ui.hdp/@:ui.ou/@:ui.oe) 11%",
    comm_limit_H: "H (@:ui.hdp/@:ui.ou/@:ui.oe) 12%",
    comm_limit_I: "I (@:ui.hdp/@:ui.ou/@:ui.oe) 13%",
    comm_limit_J: "J (@:ui.hdp/@:ui.ou/@:ui.oe) 14%",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile",
    update_hdp_packages: "@:ui.update @:ui.hdp_packages",
  },

  downline_id: "ดาวน์ไลน์ ID",
  disabled: "พิการ",
  downline: "ดาวน์ไลน์",
  dashboard: "แผงควบคุม",
  downline_list: "รายการดาวน์ไลน์",
  double_chance: "สองโอกาส",
  downline_credit: "เครดิตดาวน์ไลน์",
  date: "วันที่",
  data: "ข้อมูล",
  date_time: "วันเวลา",
  date_range: "ช่วงวันที่",
  details: "รายละเอียด",
  draw: "วาด",
  daily_statement: "รายงาน",
  daily_statement_member: "รายงานสมาชิก ประจำวัน",
  daily_winlose: "ชนะ แพ้ ประจำวัน",
  daily_winlose_simple: "ชนะ แพ้ ธรรมดา",
  daily_winlose_details: "ชนะ แพ้ ",
  daily_reset: "ทุกวันรีเซ็ต",
  daily_winlose_platform: "ชนะ แพ้ ผลิตภัณฑ์",
  daily_winlose_match: "แมทช์ ชนะ แพ้",
  detail: "Detail",
  downline_outstanding: "Downline Outstanding",
  dd: "ครึ่งเวลา: เสมอกัน l เต็มเวลา: เสมอกัน",
  dh: "ครึ่งเวลา: เสมอกัน l เต็มเวลา: เจ้าบ้าน ",
  da: "ครึ่งเวลา: เสมอกัน l เต็มเวลา: ทีมเยือน",
  dnb: "เสมอไม่เดิมพัน",
  draw_cancel: "เสมอกัน",
  default: "ค่าเริ่มต้น",

  edit: "แก้ไข",
  enter_information: "ป้อนข้อมูล",
  enable: "เปิด",
  esports: "E-กีฬา",
  edit_account: "แก้ไขบัญชี",
  edit_limit: "แก้ไขขีด จำกัด",
  early: "ล่วงหน้า",
  event: "เหตุการณ์",
  enabled: "เปิด",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "แม้",
  edited: "แก้ไข",
  export_excel: "ส่งออก Excel",

  from: "จาก",
  full: "เต็ม",

  forecast: " ยอดการเล่นและคำนวณผล",
  forecast_soccer: " ยอดการเล่นและคำนวณผล ฟุตบอล",
  freeze: "Freeze",
  full_name: "ชื่อ",
  full_mode: "โหมดเต็มรูปแบบ",
  first_hdp: "ครึ่งเวลา แฮนดีแคพ ",
  first_ou: "ครึ่งเวลา สูงกว่า ต่ำกว่า",
  fh: "ครึ่งเวลา ",
  forecast_details: "รายละเอียดการคาดการณ์",
  full_time: "เต็มเวลา",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "ประตูแรก",
  first_half: "ครึ่งแรก",

  grand_total: "ยิ่งใหญ่รวม",
  gross_commission: "ค่าคอมรวม",
  game_name: "ชื่อเกม",
  game_provider: "ผู้ให้บริการเกม",
  game_result: "ผลลัพธ์ของเกม",
  game_result_details: "รายละเอียดผลลัพธ์ของเกม",
  gross_winlose: "Gross Win Lose",
  game_type: "ประเภทเกม",

  ht: "ครึ่งแรก",
  half: "ครึ่ง",
  half_time: "ครึ่งแรก",
  home: "บ้าน",
  hdp: "แต้มต่อ",
  hdp_packages: "แพ็คเกจแฮนดิแคป",
  home_team_name: "ชื่อทีมเจ้าบ้าน",
  home_score: "ทีมเหย้า คะแนน",
  hh: "ครึ่งเวลา: ทีมเหย้า | เต็มเวลา: ทีมเหย้า",
  hd: "ครึ่งเวลา: ทีมเหย้า | เต็มเวลา: เสมอกัน",
  ha: "ครึ่งเวลา: ทีมเหย้า | เต็มเวลา: ทีมเยือน",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "ไม่มีการวางเดิมพันทีมเหย้า",

  ip_address: "ที่อยู่ IP",
  id: "ID",

  key: "Key",
  keno: "คีโน",
  keno_bet_limit_packages: "แพคเกจวงเงินเดิมพันของคีโน",

  log_id: "บันทึก ID",
  lottery: "สลากกินแบ่ง",
  lottery_1d: "ลอตเตอรี 1D",
  lottery_2d: "ลอตเตอรี 2D",
  lottery_3d: "ลอตเตอรี 3D",
  lottery_4d: "ลอตเตอรี 4D",
  lotto: "เกมพนันชนิดหนึ่ง",
  log: "บันทึก",
  list: "รายการ",
  logs: "บันทึก",
  login: "เข้าสู่ระบบ",
  logout: "ออกจากระบบ",
  login_ip: "เข้าสู่ระบบ IP",
  login_id: "เข้าสู่ระบบ ID",
  last_name: "นามสกุล",
  live_casino: "คาสิโนสด",
  livecasino: "คาสิโนสด",
  lastweek: "อาทิตย์ที่แล้ว",
  lastmonth: "เดือนที่แล้ว",
  last3month: "3 เดือนล่าสุด",
  league_id: "ลีกค์ ID",
  league_name: "ชื่อลีก",
  league: "ลีกค์",
  livecasino_platform: "แพลตฟอร์ม คาสิโนสด",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "แพ็คเกจ จำกัด การเดิมพัน คาสิโนสด",
  last_goal: "เป้าหมายสุดท้าย",
  live: "มีชีวิต",
  lose: "แพ้",
  lose_half: "เสียครึ่ง",
  last_week: "อาทิตย์ที่แล้ว",
  last_month: "เดือนที่แล้ว",
  lotto_bet_limit_packages: "แพ็คเกจ จำกัด การเดิมพันล็อตโต้",
  lottery_bet_limit_packages: "แพ็คเกจ จำกัด การเดิมพันลอตเตอรี",

  member_log: "สมาชิกบันทึก",
  member_balance: "ยอดเงินสมาชิก",
  master_credit: "มาสเตอร์ เครดิต",
  member_credit_limit: "สมาชิกเครดิต ",
  max_credit_limit: "วงเงินเครดิตสูงสุด",
  min_max_bet: "เดิมพัน ต่ำสุด/เดิมพัน สูงสุด",
  min_bet: "เดิมพัน ต่ำสุด",
  max_bet: "เดิมพัน สูงสุด",
  max_per_match: "สูงสุดต่อแมทช์ :",
  mix_parlay: "มิกซ์ พาร์เลย์",
  mmo_parlay: "Myanmar Parlay",
  money_line: "มันนี่ไลน์",
  min: "ขั้นต่ำ",
  max: "มากที่สุด",
  market_type: "ประเภทตลาด",
  match_time: "ตรงกับเวลา",
  match_id: "การจับคู่ ID",
  member_id: "ชื่อผู้ใช้",
  match: "การจับคู่",
  master_outstanding: "การเดิมพันที่ยังไม่สิ้นสุดของ มาสเตอร์",
  mode: "โหมด",
  member_outstanding: "การเดิมพันที่ยังไม่สิ้นสุดของ สมาชิก ",
  match_result: "ผลแมทช์ ",
  messages: "ข่าวสาร",
  message: "ข่าวสาร",
  member_management: "การจัดการสมาชิก",
  member_bulk: "Member Bulk",
  manila_nocomm: "ค่าคอมมิชชั่นของ Manila Suite 0%",

  new: "ใหม่",
  new_login_id: "รหัสเข้าสู่ระบบใหม่",
  new_username: "ชื่อผู้ใช้ใหม่",
  new_password: "รหัสผ่านใหม่",
  new_security_code: "รหัสความปลอดภัยใหม่",
  new_account: "บัญชีใหม่",
  next: "ต่อไป",
  no_goal: "ไม่มีเป้าหมาย",
  "no/": "ไม่.",
  normal: "ปกติ",
  normal_announcements: "ประกาศปกติ",

  on: "เปิด",
  off: "ปิด",
  ok: "ตกลง.",
  over: "เกิน",
  overview: "ภาพรวม",
  old_password: "รหัสผ่านเก่า",
  outstanding: "การเดิมพันที่ยังไม่สิ้นสุด",
  outstanding_balance: "การเดิมพันที่ยังไม่สิ้นสุดยอดคงเหลือ",
  over_under: "สูงกว่า / ต่ำกว่า",
  odd_even: "คู่ / คี่",
  ou: "สูงกว่า ต่ำกว่า",
  oe: "คู่คี่",
  others: "อื่นๆ",
  odd: "คู่",
  oxt: "1X2",
  outright: "ทายผลผู้ชนะ",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",
  odds_display: "Odds Display",
  online_player: "ผู้เล่นออนไลน์",
  opening_balance: "ยอดคงเหลือต้นงวด",
  oxtoeml: "@:ui.oe/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "แฮนดิแคป 3 ทาง",
  others_sports: "กีฬาอื่น ๆ",
  opkey: "OP Key",
  operator_limit: "Operator Limit",

  pending: "รอดำเนินการ",
  platform: "เวที",
  pt: "เปอร์เซ็นที่รับความเสี่ยง",
  password: "รหัสผ่าน",
  profile_id: "ข้อมูลส่วนตัว ID",
  parent_id: "Parent ID",
  page_size: "ขนาดหน้ากระดาษ",
  profile: "ข้อมูลส่วนตัว",
  payment_option: "ตัวเลือกการชำระเงิน",
  part_one: "ส่วนที่หนึ่ง",
  part_two: "ส่วนที่สอง",
  position_taking: "เปอร์เซ็นที่รับความเสี่ยง",
  preview_settings: "ดูตัวอย่างการตั้งค่า",
  preview: "ดูตัวอย่าง",
  parlay: "พาร์เลย์",
  position_taking_log: "เปอร์เซ็นที่รับความเสี่ยงบันทึก",
  platform_code: "รหัสแพลตฟอร์ม",
  platform_name: "ชื่อแพลตฟอร์ม",
  pay: "จ่าย | จ่ายทั้งหม",
  payout: "จ่าย",
  product: "ผลิตภัณฑ์",
  pending_matches: "ในระหว่างคานวณ",
  pt_share: "Position Shares",
  platform_settings: "การตั้งค่าแพลตฟอร์ม",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  personal: "ส่วนบุคคล",
  personal_message: "ข้อความส่วนตัว",
  password_reset: "รหัสผ่าน รีเซ็ต",
  password_update: "รหัสผ่าน ปรับปรุง",

  refresh: "รีเฟรช",
  reset: "ตั้งค่าใหม่",
  remaining_credit: "เครดิตที่เหลืออยู่",
  remaining: "ที่เหลืออยู่",
  rate: "Rate",
  report: "รายงาน",
  running: "ที่กำลังแข่งขัน",
  remark: "หมายเหตุ",
  refund: "คืนเงินให้",
  range: "พิสัย",
  reject: "ปฏิเสธ",
  reset_accumulate_win: "Reset Accumulated Win",
  room_type: "ประเภทห้อง",
  room_status: "สถานะห้อง",
  room_id: "รหัสห้อง",
  room_host: "โฮสต์ห้อง",
  reason: "เหตุผล",
  room_match: "จับคู่ห้อง",

  status: "สถานะ",
  succeed: "ประสบความสำเร็จ",
  submit: "ตกลง",
  settings: "การตั้งค่า",
  save: "บันทึก",
  search: "ค้นหา",
  suspend: "ระงับ",
  security_tag: "Security Tag",
  sub_account: "บัญชีย่อย ",
  search_and_copy: "ค้นหาและคัดลอก",
  search_existing: "Search Existing",
  skip: "Skip",
  settings_limit: "การตั้งค่าจำกัด",
  sportsbook: "หนังสือกีฬา",
  slot_games: "สล็อต",
  soccer: "ฟุตบอล",
  sport_types: "หมวดหมู่กีฬา",
  settlement: "การตั้งถิ่นฐาน",
  submatch_id: "Sub-match ID",
  score: "คะแนน",
  submatch_code: "Sub-match Code",
  settlement_list: "การตั้งถิ่นฐานรายการ",
  sub_total: "ไม่ทั้งหมด",
  settle_amount: "จำนวนเงินการชำระบัญชี",
  settlement_history: "ประวัติการตั้งถิ่นฐาน",
  settlement_member: "รายละเอียดการตั้งถิ่นฐานของสมาชิก",
  sport_type: "หมวดหมู่กีฬา",
  slot_platform: "แพลตฟอร์มสล็อต",
  simple_report: "รายงานอย่างง่าย",
  status_update: "Update Status",
  set_authority: "Set Authority",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "สล็อต",
  security_update: "การปรับปรุงความปลอดภัย",
  security_code: "รหัสรักษาความปลอดภัย",
  success: "ความสำเร็จ",
  stock: "สต็อก",
  special: "พิเศษ",
  special_announcements: "ประกาศพิเศษ",
  seconds: "วินาที",
  security_disable: "Security Disabled",
  select_all: "เลือกทั้งหมด",

  schedule_1: "วันจันทร์ | วันจันทร์",
  schedule_2: "วันอังคาร | วันอังคาร",
  schedule_3: "วันพุธ | วันพุธ",
  schedule_4: "วันพฤหัสบดี | วันพฤหัสบดี",
  schedule_5: "วันศุกร์ | วันศุกร์",
  schedule_6: "วันเสาร์ | วันเสาร์",
  schedule_7: "วันอาทิตย์ | วันอาทิตย์",

  twtn: "ชนะโดยไม่เสียประตู",
  total_outstanding: "การเดิมพันที่ยังไม่สิ้นสุดยอดรวม",
  target_id: "Target ID",
  target_action: "Target Action",
  total: "ยอดรวม",
  types: "ประเภท",
  total_goal: "ประตูรวม",
  tennis: "เทนนิส",
  today: "ในวันนี้",
  thisweek: "ในสัปดาห์นี้",
  thismonth: "เดือนนี้",
  transaction_log: "บันทึกธุรกรรม",
  total_bet: "ยอดรวมจำนวนเดิมพัน",
  transaction_date: "วันที่ทำธุรกรรม / เวลา",
  transfer_method: "วิธีการโอน",
  turnover: "ผลประกอบการ",
  total_balance: "ยอดรวมคงเหลือ",
  total_tran: "ยอดรวมนที่ทำธุรกรรม",
  total_base: "Total Member Bet",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "10 อันดับแรกผู้ชนะของเดือน",
  top_turnover: "10 อันดับการหมุนเวียนสูงสุดของเดือน",
  type: "ชนิด",
  total_downline: "รวมดาวน์ไลน์",
  to: "ถึง",
  transfer: "โอน",
  transfer_list: "รายการโอน",
  transfer_history: "โอนประวัติ",
  this_month: "เดือนนี้",
  this_week: "ในสัปดาห์นี้",

  under: "ภายใต้",
  upline_id: "Upline ID",
  unblock: "เลิกบล็อก",
  update: "ล่าสุด",
  username: "ชื่อผู้ใช้",
  update_commission_sb: "ค่าคอมมิชชั่นหนังสือกีฬา",
  update_commission_lc: "ค่าคอมมิชชั่น คาสิโน สด",
  update_commission_sl: "ค่าคอมมิชชั่น สล็อต",
  update_commission_lo: "ค่าคอมมิชชั่น เกมพนันชนิดหนึ่ง",
  update_commission_kn: "ค่าคอมมิชชั่น คีโน",
  update_commission_cf: "ค่าคอมมิชชั่นชนไก่",
  update_commission_lt: "ค่าคอมมิชชั่น สลากกินแบ่ง",
  update_bet_limit_lc: "วงเงินเดิมพัน คาสิโนเกมส์สด",
  update_bet_limit_sb: "วงเงินเดิมพัน หนังสือกีฬา",
  update_bet_limit_lo: "วงเงินเดิมพัน เกมพนันชนิดหนึ่ง",
  update_bet_limit_kn: "วงเงินเดิมพัน คีโน",
  update_bet_limit_cf: "วงเงินเดิมพัน ชนไก่",
  update_bet_limit_lt: "วงเงินเดิมพัน ล็อตเตอรี่ ",
  update_position_sb: "เปอร์เซ็นที่รับความเสี่ยง หนังสือกีฬา",
  update_position_lc: "เปอร์เซ็นที่รับความเสี่ยง คาสิโน สด",
  update_position_sl: "เปอร์เซ็นที่รับความเสี่ยง สล็อต",
  update_position_lo: "เปอร์เซ็นที่รับความเสี่ยง เกมพนันชนิดหนึ่ง",
  update_position_kn: "เปอร์เซ็นที่รับความเสี่ยง คีโน",
  update_position_cf: "เปอร์เซ็นที่รับความเสี่ยง ชนไก่",
  update_position_lt: "เปอร์เซ็นที่รับความเสี่ยง ล็อตเตอรี่ ",
  update_account: "Update Account",
  update_platform: "Update Platform",
  upline_pt: "Upline PT",
  upline_remaining: "Upline Remaining",
  unblock_profile: "ข้อมูลส่วนตัวเลิกบล็อก",
  unselect_all: "Un-select All",

  view_details: "View Details",
  view_downline: "View Downline",
  value: "Value",
  valid_turnover: "Valid Turnover",
  void: "ศูนย์",

  winlose_limit: "Win Lose Limit",
  wallet: "กระเป๋าสตางค์",
  winlose: "ชนะ แพ้ ",
  win_limit: "จำกัด การชนะ",
  win_limit_multiplier: "Win Limit Multiplier",
  win_limit_tooltips: "Only applicable for Livecasino.",
  win_limit_tooltips1: "Due to Casino API latency, players may be able to continue betting for a few minutes after reaching Win Limit. ",
  win_limit_0: "ไม่ จำกัด",
  win_limit_1: "เครดิตจำกัด x 1",
  win_limit_2: "เครดิตจำกัด x 2",
  win_limit_5: "เครดิตจำกัด x 5",
  win_limit_10: "เครดิตจำกัด x10",
  win_limit_20: "เครดิตจำกัด x20",
  winlose_column1: "ชนะ/แพ้ ",
  winlose_column2: "คอมมิชชั่น",
  winlose_today: "ชนะแพ้ ในวันนี้",
  winlose_yesterday: "ชนะแพ้ เมื่อวาน",
  winner: "ผู้ชนะ",
  won: "วอน",
  win_half: "ชนะครึ่ง",

  yesterday: "เมื่อวาน",
  yesterday_balance: "ยอดคงเหลือของเมื่อวาน",

  provider_evo: "Evolution Gaming",
  provider_gp: "Manila suite",
  provider_vivo: "Vegas suite",
  provider_sa: "Bangkok suite",
  provider_ct: "Hanoi suite",
  provider_slots: "สล็อต",
  provider_lotto: "สลากกินแบ่ง",
  provider_keno: "คีโน",
  provider_cockfight: "ชนไก่",
  provider_lottery: "หวย",

  suffix: "Suffix",
  callback_url: "Callback URL",
  email: "Email",
  seamless: "Seamless",
  key: "Key",
  inactive: "Inactive",

  ip_settings: "IP Settings",
  updated_on: "Updated On",
  updated_by: "Updated By",
  add_ip: "Add IP",
  ip: "IP",
  whitelisted_ip: "Whitelisted IP",
  cash_deposit: "Cash Deposit",
  cash_withdrawal: "Cash Withdrawal",
  fail: "Failed",
  
  timer: "เครื่องจับเวลา",
  no_refresh: "ไม่มีการรีเฟรช",
  actual_yesterday_balance: "ยอดคงเหลือเมื่อวานจริง",

  bet_limit_default: "Bet Limit Default",
  bet_limit_single: "Bet Limit Single",
  hdp_package: "HDP Package",
  update_hdp_package: "Update HDP Package",
  update_bet_limit_default: "Update Bet Limit Default",
  update_bet_limit_single: "Update Bet Limit Single",

  refno: "Ref No.",
  system_parlay: "เดิมพันระบบ",
  total_accepted: "รวมได้รับการยอมรับ",
  total_rejected: "รวมปฏิเสธ",
  total_stake: "เดิมพันรวม",
  total_winlose: "รวม ชนะ แพ้",
  fold: "พับ",
  combination: "การรวมกัน",

  running_score: "คะแนนการวิ่ง",
  abandoned: "ถูกทอดทิ้ง",
  tournament: "ทัวร์นาเมนต์",
  tournament_match: "การแข่งขันทัวร์นาเมนต์",
  tournament_refund_list: "รายการคืนเงินการแข่งขัน",
  room_1: "สาธารณะ",
  room_2: "ส่วนตัว",
  room_3: "สาธารณะ (ฟรี)",
  op_tournament: "โอพี ทัวร์นาเมนต์",
  adjustment: "การปรับตัว",

  start_time: "เวลาเริ่มต้น",
  sport: "กีฬา",
  entry_points: "แต้มเข้าร่วม",
  operator: "ผู้ให้บริการ",
  players_joined: "ผู้เล่นที่เข้าร่วม",
  total_league: "จำนวนลีกทั้งหมด",
  total_match: "จำนวนการแข่งขันทั้งหมด",
  pool: "เงินรางวัลรวม",
  players: "ผู้เล่น",
  pay_type: "ประเภทการชำระเงิน",
  plus: "เพิ่ม",
  jackpot: "แจ็กพอต",
  formula: "สูตร",

  public: "สาธารณะ",
  private: "ส่วนตัว",
  public_free: "สาธารณะ (ฟรี)",
  three_winner: "ผู้ชนะ 3 คน",
  one_winner: "ผู้ชนะ 1 คน",

  cashout: "ถอนเงิน",

  password_rules: "กฎรหัสผ่าน",
  password_rules_intro: "รหัสผ่านต้องเป็นไปตามกฎดังต่อไปนี้:",
  security_code_rules: "กฎรหัสความปลอดภัย",
  security_code_rules_intro: "รหัสความปลอดภัยต้องเป็นไปตามกฎดังต่อไปนี้:",

  // OTP 2FA Translations
  setup_otp_via_mobile_authenticator: "ตั้งค่า OTP ผ่านแอปยืนยันตัวตนบนมือถือ",
  step_1_download_google_authenticator: "1. ดาวน์โหลด Google Authenticator บนอุปกรณ์ของคุณ",
  step_2_create_account_scan_qr: "2. สร้างบัญชีโดยสแกน QR code นี้ด้วย Google Authenticator",
  step_3_enter_6_digit_code_verify: "3. กรอกรหัส 6 หลักที่สร้างโดย Google Authenticator ในช่องข้อความด้านล่าง แล้วคลิกยืนยันเพื่อเสร็จสิ้นการลงทะเบียน",
  download_on_app_store: "ดาวน์โหลดบน App Store",
  get_it_on_google_play: "ดาวน์โหลดบน Google Play",
  regenerate_qr: "สร้าง QR Code ใหม่",
  unable_to_scan_qr_code: "ไม่สามารถสแกน QR code ได้?",
  manual_entry_secret: "รหัสลับสำหรับกรอกด้วยตนเอง",
  otp: "OTP",
  verify: "ยืนยัน",
  enable_otp_via_mobile_authenticator_app: "เปิดใช้งาน OTP ผ่านแอปยืนยันตัวตนบนมือถือ",
  two_factor_authenticator_bound: "ยืนยันตัวตนแบบสองขั้นตอนถูกผูกไว้แล้ว",
  unbind: "ยกเลิกการผูก",
  setup_2fa: "ตั้งค่า 2FA",
  enter_6_digit_code: "กรอกรหัส 6 หลัก",
};